import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Datepicker } from '@wmgtech/legato'
import { MonthPickerHeader } from './MonthPickerHeader'
import { DateRangePickerCustomProps } from './DateRangePicker.props'

import styles from './DateRangePicker.module.scss'

export const MonthPicker: FC<DateRangePickerCustomProps> = ({
  startDate,
  value,
  onChange,
  isSelected,
}) => {
  return <Datepicker
    className={cn('items-list__item', styles.inputButton, {
      'items-list__item--checked': isSelected
    })}
    onChange={onChange}
    placeholder="Select month"
    value={value}
    selected={startDate}
    size="md"
    showMonthYearPicker
    calendarContainer={({ className, children }: any) =>
      <div className={cn(className, styles.month)}>{children}</div>
    }
    renderCustomHeader={MonthPickerHeader}
  />
}
